import { useTranslation } from "react-i18next";

interface LanguageSwitcherProps {
  variant?: "dark" | "light";
}

export default function LanguageSwitcher({ variant = "light" }: LanguageSwitcherProps) {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage?.startsWith("en") || i18n.language?.startsWith("en") ? "en" : "ko";

  const handleChange = (next: "ko" | "en") => {
    i18n.changeLanguage(next).then(() => {
      try {
        window.localStorage.setItem("site_language", next);
      } catch {
        // ignore storage errors
      }
    });
  };

  return (
    <div
      className={`inline-flex items-center rounded-full p-[3px] text-xs font-bold select-none border ${
        variant === "dark"
          ? "bg-background-50/10 border-background-50/30"
          : "bg-background-100 border-background-300/80"
      }`}
      role="group"
      aria-label="Language switcher"
    >
      {(["ko", "en"] as const).map((code) => (
        <button
          key={code}
          type="button"
          onClick={() => handleChange(code)}
          aria-pressed={current === code}
          className={`px-3 py-[5px] rounded-full cursor-pointer whitespace-nowrap transition-colors ${
            current === code
              ? variant === "dark"
                ? "bg-background-50 text-foreground-950"
                : "bg-foreground-950 text-background-50"
              : variant === "dark"
                ? "text-background-50/60 hover:text-background-50"
                : "text-foreground-500 hover:text-foreground-900"
          }`}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}